import { CarSliderGalleryAttributes } from './carDataAttributes';
import { WatchSliderGalleryAttributes } from './watchDataAttributes';
import { OtherSliderGalleryAttributes } from './otherDataAttributes';
import { ComicSliderGalleryAttributes } from './comicDataAttributes';
import { ArtSliderGalleryAttributes } from './artDataAttributes';
import { AntiqueSliderGalleryAttributes } from './antiqueDataAttributes';
import { BookSliderGalleryAttributes } from './bookDataAttributes';
import { CoinSliderGalleryAttributes } from './coinDataAttributes';
import { StampSliderGalleryAttributes } from './stampDataAttributes';
import { CameraSliderGalleryAttributes } from './cameraDataAttributes';
import { FirearmSliderGalleryAttributes } from './firearmDataAttributes';
import { HandbagSliderGalleryAttributes } from './handbagDataAttributes';
import { JewelrySliderGalleryAttributes } from './jewelryDataAttributes';
import { ToySliderGalleryAttributes } from './toyDataAttributes';
import { HistoricalMemSliderGalleryAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemSliderGalleryAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentSliderGalleryAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemSliderGalleryAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemSliderGalleryAttributes } from './sportsMemorabiliaDataAttributes';
import { WineSliderGalleryAttributes } from './wineDataAttributes';
import { SportsCardSliderGalleryAttributes } from './sportsCardDataAttributes';
import { VinylRecordSliderGalleryAttributes } from './vinylRecordDataAttributes';
import { convertType } from './constants';

export default class SliderGalleryAttributes {
  constructor({
    title,
    subtitle,
  }) {
    this.title = title;
    this.subtitle = subtitle;
  }


  static AttributesFromGenericItemModel(item) {
    let sliderGalleryAttributes;

    switch (convertType(item.category)) {
      case 'CAR':
        sliderGalleryAttributes = CarSliderGalleryAttributes;
        break;

      case 'WATCH':
        sliderGalleryAttributes = WatchSliderGalleryAttributes;
        break;

      case 'COMIC':
        sliderGalleryAttributes = ComicSliderGalleryAttributes;
        break;

      case 'OTHER':
        sliderGalleryAttributes = OtherSliderGalleryAttributes;
        break;

      case 'ART':
        sliderGalleryAttributes = ArtSliderGalleryAttributes;
        break;

      case 'ANTIQUE':
        sliderGalleryAttributes = AntiqueSliderGalleryAttributes;
        break;

      case 'BOOK':
        sliderGalleryAttributes = BookSliderGalleryAttributes;
        break;

      case 'COIN':
        sliderGalleryAttributes = CoinSliderGalleryAttributes;
        break;

      case 'STAMP':
        sliderGalleryAttributes = StampSliderGalleryAttributes;
        break;

      case 'CAMERA':
        sliderGalleryAttributes = CameraSliderGalleryAttributes;
        break;

      case 'FIREARM':
        sliderGalleryAttributes = FirearmSliderGalleryAttributes;
        break;

      case 'HANDBAG':
        sliderGalleryAttributes = HandbagSliderGalleryAttributes;
        break;

      case 'JEWELRY':
        sliderGalleryAttributes = JewelrySliderGalleryAttributes;
        break;

      case 'TOY':
        sliderGalleryAttributes = ToySliderGalleryAttributes;
        break;

      case 'SPORTS_CARD':
        sliderGalleryAttributes = SportsCardSliderGalleryAttributes;
        break;

      case 'VINYL_RECORD':
        sliderGalleryAttributes = VinylRecordSliderGalleryAttributes;
        break;

      case 'MUSICAL_MEM':
        sliderGalleryAttributes = MusicMemSliderGalleryAttributes;
        break;

      case 'SPORTS_MEM':
        sliderGalleryAttributes = SportsMemSliderGalleryAttributes;
        break;

      case 'HISTORIC_MEM':
        sliderGalleryAttributes = HistoricalMemSliderGalleryAttributes;
        break;

      case 'MOVIE_MEM':
        sliderGalleryAttributes = MovieMemSliderGalleryAttributes;
        break;

      case 'MUSICAL_INST':
        sliderGalleryAttributes = MusicalInstrumentSliderGalleryAttributes;
        break;

      case 'WINE':
        sliderGalleryAttributes = WineSliderGalleryAttributes;
        break;


      default:
        throw new Error('Unknown item type');
    }

    const { titleKey, subtitleKey } = sliderGalleryAttributes;

    return new SliderGalleryAttributes({
      title: (titleKey === 'title' ? item.itemData[titleKey] : item.specificData[titleKey]),
      subtitle: item.specificData[subtitleKey],
    });
  }
}



// WEBPACK FOOTER //
// ./src/config/sliderGalleryAttributes.js